export const STATUS_LABELS = {
  taslak: "Taslak",
  planlandi: "Planlandı",
  yolda: "Yolda",
  aktarma: "Aktarma",
  varista: "Varışta",
  teslim_edildi: "Teslim Edildi",
  kapandi: "Kapandı",
  iptal: "İptal",
  arsiv: "Arşiv",
  yeni: "Yeni",
  teklif_toplaniyor: "Teklif Toplanıyor",
  teklif_verildi: "Teklif Verildi",
  onaylandi: "Onaylandı",
  hazir: "Hazır",
  eksik: "Eksik",
  tamam: "Tamam",
  bekliyor: "Onay Bekliyor",
  onayli: "Onaylı",
};

export const MODE_LABELS = { kara: "Kara", deniz: "Deniz", hava: "Hava" };
export const DIRECTIONS = ["export", "transit", "import"];
export const DIRECTION_LABELS = { export: "Export", transit: "Transit", import: "Import" };

const TONE = {
  iptal: "bg-red-50 text-red-700 border-red-200",
  yolda: "bg-blue-50 text-blue-700 border-blue-200",
  aktarma: "bg-blue-50 text-blue-700 border-blue-200",
  teslim_edildi: "bg-green-50 text-green-700 border-green-200",
  kapandi: "bg-green-50 text-green-700 border-green-200",
  tamam: "bg-green-50 text-green-700 border-green-200",
  onayli: "bg-green-50 text-green-700 border-green-200",
  onaylandi: "bg-green-50 text-green-700 border-green-200",
  eksik: "bg-yellow-50 text-yellow-800 border-yellow-300",
  bekliyor: "bg-yellow-50 text-yellow-800 border-yellow-300",
};

export const Badge = ({ value, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${
      TONE[value] || "bg-zinc-100 text-zinc-700 border-zinc-300"
    }`}
  >
    {STATUS_LABELS[value] || value}
  </span>
);

export const MarginTag = ({ pct, testId }) => (
  <span
    data-testid={testId}
    className={`tnum font-mono text-sm font-semibold ${
      pct < 5 ? "text-red-600" : pct < 12 ? "text-yellow-700" : "text-green-700"
    }`}
  >
    {Number(pct || 0).toFixed(1)}%
  </span>
);
